import { lt } from '@mews/framework';
import { useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { SpacedDash, LocalizedDateFromUtc } from '@mews-commander/ui';
import { PaymentLinkDetailItem } from './PaymentLinkDetailItem';

export const ServiceOrderDatesInfoRow = ({ serviceOrderId }: { serviceOrderId: string }) => {
    const { data: serviceOrder } = useRepositorySuspenseQuery(
        'reservations',
        'getAll',
        {
            reservationIds: [serviceOrderId],
        },
        { select: (data) => data.reservations?.[0] }
    );

    if (!serviceOrder) {
        return null;
    }

    const dates = (
        <>
            <LocalizedDateFromUtc utcString={serviceOrder.startUtc} />
            {SpacedDash}
            <LocalizedDateFromUtc utcString={serviceOrder.endUtc} />
        </>
    );

    return <PaymentLinkDetailItem description={lt('DatePlural')} value={dates} />;
};
